import Vue from "vue"
import { mapState } from "vuex"
import { SET_VOLUME } from '@/store/mutation-types'


Vue.use({
    install(Vue) {
        Vue.mixin({

            data() {
                return {
                    BASE_URL: process.env.VUE_APP_BASE_URL,
                }

            },
            computed: {
                ...mapState({
                    processing: state => state.loading,
                    isLoggedIn: state => state.auth.isLoggedIn,
                    authUser: state => state.auth.authUser,
                    onLine: state => state.auth.onLine,
                    station_info: state => state.stations.station_info,
                    stationId: state => state.stations.stationId,
                    station: state => state.stations.selectedStation,
                    listener_info: state => state.dashboard.listeners,
                    server_errors: state => state.errors
                }),

                volume: {
                    get() {
                        return this.$store.state.volume;
                    },
                    set(vol) {
                        this.$store.commit(SET_VOLUME, parseInt(vol));
                    }
                },

                purchase() {
                    return this.station_info.purchase ? this.station_info.purchase : {}
                },

                mainPlan() {
                    return this.purchase.main_plan ? this.purchase.main_plan : {}
                },

                planBenefits() {
                    return this.mainPlan.benefits ? this.mainPlan.benefits : {}
                },

                onAir() {
                    return this.station_info.server_running
                },
                invoices() {
                    return this.station_info.invoices
                },
             
                allPlans() {
                    return this.station_info? this.station_info.all_plans: {}
                },


                mounts() {
                    return this.station.mounts ? this.station.mounts : []
                },

                listeners() {
                    return this.station_info.listeners ? this.station_info.listeners : {}
                },

                total_bandwith() {
                    return this.station_info.listener_info ? this.station_info.listener_info.total_bandwith : 0
                },

                now_playing() {
                    return this.station_info.now_playing ? this.station_info.now_playing : {}
                },

                current_track() {
                    return this.now_playing.track ? this.now_playing.track : {}
                },

                next_playing() {
                    return this.station_info.next_playing ? this.station_info.next_playing : {}
                },

                next_track() {
                    return this.next_playing.track ? this.next_playing.track : {}
                },

                live() {
                    return this.station_info.live ? this.station_info.live : {}
                },

                schedule() {
                    return this.station_info.schedule ? this.station_info.schedule : []
                },


                track_history() {
                    return this.station_info.track_history ? this.station_info.track_history : []
                },


                scheduleItems() {
                    let scheduleItems = this.schedule;
                    let now = moment();

                    scheduleItems.forEach(function(row, index) {
                        let start_moment = moment.unix(row.start_timestamp);
                        let end_moment = moment.unix(row.end_timestamp);

                        this[index].time_until = start_moment.fromNow();

                        if (start_moment.isSame(now, 'day')) {
                            this[index].start_formatted = start_moment.format('LT');
                        } else {
                            this[index].start_formatted = start_moment.format('llll');
                        }

                        if (end_moment.isSame(start_moment, 'day')) {
                            this[index].end_formatted = end_moment.format('LT');
                        } else {
                            this[index].end_formatted = end_moment.format('lll');
                        }
                    }, scheduleItems);


                    return scheduleItems;
                },

            },

        })
    }
})